/* Simple per-page password gate */
(function () {
  function getParam(name) {
    const m = new URLSearchParams(window.location.search).get(name);
    return m ? m.trim() : "";
  }

  function unlock(wrapper) {
    const formBox = wrapper.querySelector(".password-form-box");
    const content = wrapper.querySelector(".locked-content");
    if (content) content.style.display = "block";
    if (formBox) formBox.style.display = "none";
  }

  function tryAutoUnlock(wrapper) {
    const expected = (wrapper.dataset.password || "").trim();
    if (!expected) return;

    const id = wrapper.id || "locker";
    const stored = localStorage.getItem("unlock:" + id);
    const urlPw = getParam("password") || getParam("pw");

    if (stored === expected || (urlPw && urlPw === expected)) {
      if (urlPw === expected) localStorage.setItem("unlock:" + id, expected);
      unlock(wrapper);
    }
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-unlock]");
    if (!btn) return;

    const wrapper = btn.closest(".password-wrapper");
    if (!wrapper) return;

    const input = wrapper.querySelector('input[type="password"]');
    const expected = (wrapper.dataset.password || "").trim();
    const entered = (input && input.value ? input.value : "").trim();

    if (!expected) {
      console.warn("No password set in section settings.");
      return;
    }

    if (entered === expected) {
      const id = wrapper.id || "locker";
      localStorage.setItem("unlock:" + id, expected);
      unlock(wrapper);
    } else {
      // simple feedback
      if (input) {
        input.style.borderColor = "#e11d48"; // red
        setTimeout(() => (input.style.borderColor = "#ddd"), 700);
      }
    }
  });

  // On load, attempt auto-unlock from URL or localStorage
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".password-wrapper[data-password]")
      .forEach(tryAutoUnlock);
  });
})();
